export const environment = {
  "production": true,
  "clientId": "3e6sv5fe9r7lr171k3pbjt2kid",
  "issuer": "https://843916760751-c83dc306206cd2b41042b8e909ee0a0aeb9a7a1712.auth.ap-northeast-2.amazoncognito.com/oauth2/token",
  "controlPlaneUrl": "https://y78545fem6.execute-api.ap-northeast-2.amazonaws.com/",
  "wellKnownEndpointUrl": "https://cognito-idp.ap-northeast-2.amazonaws.com/ap-northeast-2_75BQzhJdv/.well-known/openid-configuration"
};
export default environment;
